namespace RioERP.Invoices {
    export interface InvoiceNumberFormatRow {
        Id?: number;
        InvoiceCompanyId?: number;
        CurrencyId?: number;
        CalculationCurrency?: number;
        SourceType?: string;
        SourceTypeId?: number[];
        SourceTypes?: string;
        InvoicePrefix?: string;
        MonthlyReset?: boolean;
        ResetDate?: string;
        Part1?: Web.Enums.EInvoiceNumberPattern;
        Part2?: Web.Enums.EInvoiceNumberPattern;
        Part3?: Web.Enums.EInvoiceNumberPattern;
        Part4?: Web.Enums.EInvoiceNumberPattern;
        AutoIncrementLimit?: string;
        IsActive?: boolean;
        InvoiceCompanyName?: string;
        InvoiceCompanyAddress?: string;
        InvoiceCompanyGstIn?: string;
        InvoiceCompanyInvoiceCode?: string;
        InvoiceCompanyIsTaxApplicable?: boolean;
        InvoiceCompanyInvoiceChangeDate?: string;
        InvoiceCompanyIsDefault?: boolean;
        InvoiceCompanyFooterNote?: string;
        InvoiceCompanyLogo1?: string;
        InvoiceCompanyLogo2?: string;
        InvoiceCompanyStampImage?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace InvoiceNumberFormatRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SourceType';
        export const localTextPrefix = 'Invoices.InvoiceNumberFormat';
        export const deletePermission = 'Invoices:InvoicesManagement:Modify';
        export const insertPermission = 'Invoices:InvoicesManagement:Modify';
        export const readPermission = 'Invoices:InvoicesManagement:View';
        export const updatePermission = 'Invoices:InvoicesManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            InvoiceCompanyId = "InvoiceCompanyId",
            CurrencyId = "CurrencyId",
            CalculationCurrency = "CalculationCurrency",
            SourceType = "SourceType",
            SourceTypeId = "SourceTypeId",
            SourceTypes = "SourceTypes",
            InvoicePrefix = "InvoicePrefix",
            MonthlyReset = "MonthlyReset",
            ResetDate = "ResetDate",
            Part1 = "Part1",
            Part2 = "Part2",
            Part3 = "Part3",
            Part4 = "Part4",
            AutoIncrementLimit = "AutoIncrementLimit",
            IsActive = "IsActive",
            InvoiceCompanyName = "InvoiceCompanyName",
            InvoiceCompanyAddress = "InvoiceCompanyAddress",
            InvoiceCompanyGstIn = "InvoiceCompanyGstIn",
            InvoiceCompanyInvoiceCode = "InvoiceCompanyInvoiceCode",
            InvoiceCompanyIsTaxApplicable = "InvoiceCompanyIsTaxApplicable",
            InvoiceCompanyInvoiceChangeDate = "InvoiceCompanyInvoiceChangeDate",
            InvoiceCompanyIsDefault = "InvoiceCompanyIsDefault",
            InvoiceCompanyFooterNote = "InvoiceCompanyFooterNote",
            InvoiceCompanyLogo1 = "InvoiceCompanyLogo1",
            InvoiceCompanyLogo2 = "InvoiceCompanyLogo2",
            InvoiceCompanyStampImage = "InvoiceCompanyStampImage",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
